import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import ChildrenPropsContext from '@xanadu/ui-shared/contexts/ChildrenPropsContext';
import { useImprovedTranslation } from '@xanadu/ui-shared/hooks';
import showLiveSupport from '@xanadu/ui-shared/utils/showLiveSupport';

import TourIcon from '../../../../images/icons/misc/icon-tour.svg';
import LiveChatIcon from '../../../../images/icons/misc/icon-livechat.svg';
import MailIcon from '../../../../images/icons/misc/icon-email.svg';

import styles from './HelpPanelActions.module.scss';

export const HelpPanelActions = ({
  clientSupportEmail = '',
  liveChatEnabled = false,
  onStartTour,
  dataHookPrefix = 'help-panel',
  layout = 'stacked',
}) => {
  const { t } = useImprovedTranslation();
  const isInline = layout === 'inline';

  const {
    featuresFlags: { enableTakeTour = true, } = {},
  } = React.useContext(ChildrenPropsContext) || {};

  const actionsClassName = classNames(styles.actions, {
    [styles['actions--inline']]: isInline,
  });

  const actionClassName = classNames(styles.action, {
    [styles['action--inline']]: isInline,
  });

  const iconClassName = classNames(styles.icon, {
    [styles['icon--inline']]: isInline,
  });

  return (
    <div className={actionsClassName}>
      {liveChatEnabled && (
        <button
          type="button"
          className={actionClassName}
          onClick={showLiveSupport}
          data-hook={`${dataHookPrefix}-live-chat`}
        >
          <LiveChatIcon className={iconClassName} />
          <span>{t('Live Chat')}</span>
        </button>
      )}
      {clientSupportEmail && (
        <a
          href={`mailto:${clientSupportEmail}`}
          className={actionClassName}
          data-hook={`${dataHookPrefix}-email`}
        >
          <MailIcon className={iconClassName} />
          <span>{t('Email')}</span>
        </a>
      )}
      {enableTakeTour && (
        <button
          type="button"
          className={actionClassName}
          onClick={onStartTour}
          data-hook={`${dataHookPrefix}-tour`}
        >
          <TourIcon className={iconClassName} />
          <span>{t('Take a Tour')}</span>
        </button>

      )}
    </div>
  );
};

HelpPanelActions.propTypes = {
  clientSupportEmail: PropTypes.string,
  liveChatEnabled: PropTypes.bool,
  onStartTour: PropTypes.func.isRequired,
  dataHookPrefix: PropTypes.string,
  layout: PropTypes.oneOf(['stacked', 'inline']),
};

export default HelpPanelActions;
